import React from 'react'

const Checked = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9C0.75 4.44365 4.44365 0.75 9 0.75Z" fill="#141B34" stroke="#141B34" strokeWidth="1.5"/>
<path d="M6 9.5625C6 9.5625 7.2 10.2469 7.8 11.25C7.8 11.25 9.6 7.3125 12 6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  )
}

export default Checked
